/* tslint:disable */
/* eslint-disable */
/**
 * chinaone-java
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  ResponseListTransportCompanyResVo,
} from '../models/index';
import {
    ResponseListTransportCompanyResVoFromJSON,
    ResponseListTransportCompanyResVoToJSON,
} from '../models/index';

/**
 * 
 */
export class TransportCompanyControllerApi extends runtime.BaseAPI {

    /**
     * 运输公司管理·下拉列表查询
     * 运输公司管理·下拉列表查询
     */
    async transportCompanyOptionsGetRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ResponseListTransportCompanyResVo>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/transport-company/options`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ResponseListTransportCompanyResVoFromJSON(jsonValue));
    }

    /**
     * 运输公司管理·下拉列表查询
     * 运输公司管理·下拉列表查询
     */
    async transportCompanyOptionsGet(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ResponseListTransportCompanyResVo> {
        const response = await this.transportCompanyOptionsGetRaw(initOverrides);
        return await response.value();
    }

}
